import { createApiRef } from '@mainstage/core-plugin-api';

export enum PrototypeStatus {
  IDEA = 'Idea',
  DISCOVERY = 'Discovery',
  VALIDATED = 'Validated',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
}

export interface SystemPrototype {
  id: number;
  name: string;
  domain: string;
  owner: string;
  status: PrototypeStatus;
  systemPrototypeType: string;
  description: string;
  purpose: string;
  keyResults?: Array<{ id: string; name: string; description: string }>;
  parameters?: Array<{
    name: string;
    type: 'string' | 'number' | 'boolean' | 'object' | 'array';
    description?: string;
    default?: string | number | boolean | object | Array<unknown>;
    required?: boolean;
    enum?: Array<string | number | boolean | object>;
  }>;
}

export type RequestOptions = {
  token?: string;
};

export interface SystemPrototypeApi {
  createSystemPrototype: (
    systemPrototype: SystemPrototype,
    options: RequestOptions,
  ) => Promise<void>;
  getSystemPrototypes: (
    options: RequestOptions,
    taxonomyRef?: string,
  ) => Promise<SystemPrototype[]>;
  getSystemPrototype: (
    id: number,
    options: RequestOptions,
  ) => Promise<SystemPrototype>;
  deleteSystemPrototype: (
    name: string,
    options: RequestOptions,
  ) => Promise<void>;
  updateSystemPrototype: (
    id: number,
    data: Partial<SystemPrototype>,
    options: RequestOptions,
  ) => Promise<void>;
  getKeyResults: (
    options: RequestOptions,
  ) => Promise<Array<{ id: string; name: string; description: string }>>;
}

export const systemPrototypeApiRef = createApiRef<SystemPrototypeApi>({
  id: 'plugin.wb.system-prototype.service',
});
